type Currencies = { [index: string]: string };

export const currencyToSymbol: Currencies = {
  EUR: '€',
  USD: '$',
};
